import React from 'react';
import Answer from "./Comment";

const CommentsList = (props) => {
    let total = props.commentaires.length || 0;
    return (
        <div className="answer-group">
            {props.commentaires.map((comment, index) => (
                <Answer
                    articleId={props.articleId}
                    topicId={props.topicId}
                    forumId={props.forumId}
                    currentUser={props.currentUser}
                    quotesIds={props.quotesIds}
                    {...comment}
                    key={comment._id}
                    handleComments = {props.handleComments}
                    quote={props.quote}
                    handleMultipleQuotes={props.handleMultipleQuotes}
                    handleMultipleCheckbox={props.handleMultipleCheckbox}
                    multipleCheckbox={props.multipleCheckbox}
                    resetComment={props.resetComment}
                    isLastCommentPage={(index + 1) === total}
                />
            ))}
        </div>
    )
}


export default CommentsList;
